module.exports = __webpack_public_path__ + "static/media/Location.b699e765.svg";